export default __webpack_public_path__ + "static/media/Contactanos.d5310c86.png";